import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddProductPage } from '@practium/features/products';
import type { ProductsTab } from '@practium/features/products';
import { ProductModel } from '@practium/features/products/components/3D/ProductModel';

export const AddProductPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as ProductsTab) || 'defensives';

	const [productName, setProductName] = useState('');
	const [productNature, setProductNature] = useState('');
	const [productManufacturer, setProductManufacturer] = useState('');
	const [productExtra, setProductExtra] = useState('');

	const handleIdentifierChange = (name: string, nature: string, manufacturer: string, extra: string) => {
		setProductName(name);
		setProductNature(nature);
		setProductManufacturer(manufacturer);
		setProductExtra(extra);
	};

	return (
		<AddProductPage
			type={type}
			onBack={() => navigate(`/produtos?tab=${type}`)}
			onIdentifierChange={handleIdentifierChange}
			preview3DSlot={
				<ProductModel
					type={type}
					name={productName}
					nature={productNature}
					manufacturer={productManufacturer}
					extra={productExtra}
				/>
			}
		/>
	);
};
